import { Wrench, Globe } from "lucide-react";

export function Footer() {
  return (
    <footer className="mt-auto px-3 pb-4 sm:px-4">
      <div className="mx-auto max-w-7xl">
        <div
          className="
            relative overflow-hidden rounded-[28px]
            border border-dtf-accent/20
            bg-[radial-gradient(circle_at_bottom_center,rgba(37,99,235,0.18),transparent_45%),linear-gradient(180deg,rgba(7,16,35,0.96)_0%,rgba(6,14,30,0.96)_100%)]
            shadow-[0_0_0_1px_rgba(245,158,11,0.05),0_0_28px_rgba(37,99,235,0.14)]
          "
        >
          {/* glow overlay */}
          <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(90deg,rgba(37,99,235,0.06),transparent_30%,transparent_70%,rgba(37,99,235,0.05))]" />
          <div className="pointer-events-none absolute inset-0 rounded-[28px] ring-1 ring-inset ring-white/5" />

          {/* bottom glow */}
          <div className="pointer-events-none absolute bottom-[-40px] left-1/2 h-40 w-40 -translate-x-1/2 rounded-full bg-dtf-blue/20 blur-3xl" />

          <div className="relative px-5 py-6 sm:px-6 sm:py-7">
            <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">

              {/* LEFT */}
              <div className="flex items-center gap-3">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl border border-dtf-blue/25 bg-dtf-blue/10 shadow-[0_0_14px_rgba(59,130,246,0.18)]">
                  <Wrench className="h-6 w-6 text-dtf-blue" />
                </div>

                <div>
                  <p className="text-white font-bold tracking-tight">
                    DTF Wizard
                  </p>
                  <p className="text-dtf-text-muted text-sm">
                    Professional Troubleshooting for DTF Print Shops
                  </p>
                </div>
              </div>

              {/* RIGHT */}
              <div className="flex items-center gap-2 text-sm text-dtf-text-muted">
                <Globe className="h-4 w-4 text-dtf-blue" />
                <a
                  href="https://support@dtfwizardapp.com"
                  target="_blank"
                  rel="noreferrer"
                  className="font-medium text-dtf-blue transition hover:text-white"
                >
                  support@dtfwizardapp.com
                </a>
              </div>
            </div>

            {/* DIVIDER */}
            <div className="mt-6 border-t border-white/8 pt-4 text-center">
              <p className="text-xs text-dtf-text-muted">
                © {new Date().getFullYear()} Apex Designs LLC. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}